<template>
  <div class="settings-nav">
    <VList class="settings-nav__list">
      <VListItem
        v-for="item in items"
        :key="item.index"
        @click="onItemClick(item.index)"
        :active="active == item.index"
        active-class="settings-nav__item-active"
        class="settings-nav__item"
        rounded="15"
      >
        <template #prepend>
          <VIcon :icon="item.icon" size="20" class="settings-nav__icon" />
        </template>
        <template #title>
          <h4>{{ $t(item.titleKey) }}</h4>
        </template>
        <template #subtitle>
          <p>{{ $t(item.descriptionKey) }}</p>
        </template>
      </VListItem>
    </VList>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

const items = [
  {
    index: 1,
    icon: "mdi-store-outline",
    titleKey: "settings.main_settings",
    descriptionKey: "settings.main_settings_description",
  },
  {
    index: 2,
    icon: "mdi-format-list-bulleted",
    titleKey: "settings.services",
    descriptionKey: "settings.services_description",
  },
  {
    index: 3,
    icon: "mdi-account-group-outline",
    titleKey: "settings.team",
    descriptionKey: "settings.team_description",
  },
  {
    index: 4,
    icon: "mdi-calendar-clock-outline",
    titleKey: "settings.schedule",
    descriptionKey: "settings.schedule_description",
  },
  {
    index: 5,
    icon: "mdi-account-cog-outline",
    titleKey: "settings.account",
    descriptionKey: "settings.account_description",
  },
];

const emit = defineEmits<{
  (e: "onChange", value: number): void;
}>();
const active = ref(1);
const onItemClick = (index: number) => {
  active.value = index;

  emit("onChange", active.value);
};
</script>

<style lang="scss" scoped>
@use "../styles/_breakpoints" as bp;

.settings-nav {
  padding: 32px;
  height: 100%;

  @include bp.tablet {
    padding: 16px;
    // Below 960px this sits stacked above the content (see
    // column-with-sidebar.vue) rather than as a fixed-height side column
    // needing its own internal scroll - let it size to its own content.
    height: auto;
  }

  &__item {
    background-color: transparent;
    padding: 10px 12px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f1f3f5;
    }

    h4 {
      color: #403838;
      font-family: "Inter", sans-serif;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 2px;
    }

    p {
      margin-bottom: 0;
      font-family: "Inter", sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 15px;
      color: #696e7c;
    }

    &-active {
      background: #403838;

      &:hover {
        background: #403838;
      }

      h4,
      p {
        color: white;
      }

      .settings-nav__icon {
        opacity: 1;
      }
    }
  }

  &__icon {
    margin-right: 4px;
    opacity: 0.7;
  }

  &__list {
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    overflow: scroll;
    height: 100%;

    @include bp.tablet {
      overflow: visible;
      height: auto;
    }
  }

  .rounded-15 {
    border-radius: 15px;
  }
}
</style>
